export const TENANT_SLUG_HEADER = "x-tenant-slug";

export function getTenantSlug(): string | undefined {
  const slug = import.meta.env.VITE_TENANT_SLUG as string | undefined;

  return slug?.trim().toLowerCase() || undefined;
}
